import {
  getMenuPageBuilderProductSelectionMode,
  MenuPageBuilderBlock,
  MenuPageBuilderProductsBlock,
} from '../shared/dbTypes/menuPageBuilder'

export const hasPageProductSelection = (blocks: MenuPageBuilderBlock[]): boolean => {
  const productBlocks = blocks.filter((block): block is MenuPageBuilderProductsBlock => block.type === 'products')
  return productBlocks.length === 0
    || productBlocks.some(block => getMenuPageBuilderProductSelectionMode(block) === 'page')
}

export const resolveProductBlockSelection = <T>(
  block: Pick<MenuPageBuilderProductsBlock, 'productKeys' | 'selectionMode'>,
  pageProducts?: T[],
  productPreviewsByKey?: Record<string, T>,
): { keys?: string[]; products?: T[]; useFilteredProducts: boolean } => {
  if (getMenuPageBuilderProductSelectionMode(block) === 'page') {
    return { products: pageProducts, useFilteredProducts: pageProducts !== undefined }
  }

  // An empty curated selection must never fall back to the page or shop catalogue.
  if (block.productKeys.length === 0) return { products: [], useFilteredProducts: false }

  if (productPreviewsByKey !== undefined) {
    return {
      products: block.productKeys
        .map(key => productPreviewsByKey[key])
        .filter((product): product is T => product !== undefined),
      useFilteredProducts: false,
    }
  }

  return { keys: block.productKeys, useFilteredProducts: false }
}
